<div class="container-fluid page" *ngIf="selectedIndex === 1">
  <div class="d-flex page__box p-3 mt-2">Govt-Schemes</div>
  <div class="page__content shadow p-3">
    <div class="page__content-data">
      <div>
        <div class="example-header" style="margin-bottom: -41px">
          <div>
            <button
              type="button"
              (click)="showViews(2)"
              class="btn btn-primary"
            >
              Add Govt-Schemes
            </button>
          </div>
          <div class="col-md-12 mat-elevation-z8 filterdata1">
            <!-- <mat-form-field>
              <input matInput  (keyup)="filtername($event.target.value)" placeholder="Name">
            </mat-form-field>&nbsp; -->
            <p class="pfilter">Filters :</p>
            <mat-form-field style="width: 500px; position: relative; top: 15px">
              <mat-select placeholder="Category">
                <mat-option
                  *ngFor="let opt of categorydatalist"
                  (click)="getcategoryforFilter(opt.categoryID)"
                  [value]="opt.categoryName"
                >
                  {{ opt.categoryName }}
                </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="marketrateform.get('MarketId').hasError('required')">
                    Please Select Market Name.
                  </mat-error> --> </mat-form-field
            >&nbsp;&nbsp;&nbsp;

            <!-- <mat-form-field>
                <input matInput [(ngModel)]="toDate" [matDatepicker]="picker" placeholder="Choose published date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>&nbsp; -->
            <!-- <mat-form-field>
                <input matInput [(ngModel)]="myDateValue" [matDatepicker]="fromdate" [max]="maxDate" #frmdate placeholder="Choose From Date"  readonly>
                <mat-datepicker-toggle matSuffix [for]="fromdate"></mat-datepicker-toggle>
                <mat-datepicker #fromdate></mat-datepicker>
              </mat-form-field>&nbsp; -->
            <!-- <mat-form-field>
                <input matInput [(ngModel)]="toDate" [matDatepicker]="picker1" placeholder="Choose To date">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>&nbsp; -->
          </div>
          &nbsp;<br />
        </div>

        <div class="example-container mat-elevation-z8 tabledata">
          <mat-table #table [dataSource]="dataSource">
            <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
            <!-- Position Column -->
            <ng-container matColumnDef="schemtTitle">
              <mat-header-cell *matHeaderCellDef>
                Scheme Title
              </mat-header-cell>
              <mat-cell *matCellDef="let govtschemedatalist">
                {{ govtschemedatalist.schemtTitle }}
              </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <!-- <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef> Description </mat-header-cell>
                <mat-cell *matCellDef="let govtschemedatalist"> {{govtschemedatalist.description}} </mat-cell>
              </ng-container> -->

            <!-- Weight Column -->
            <ng-container matColumnDef="datePosted">
              <mat-header-cell *matHeaderCellDef> Date Posted </mat-header-cell>
              <mat-cell *matCellDef="let govtschemedatalist">
                {{ govtschemedatalist.datePosted }}
              </mat-cell>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="categoryName">
              <mat-header-cell *matHeaderCellDef>
                Category Name
              </mat-header-cell>
              <mat-cell *matCellDef="let govtschemedatalist">
                {{ govtschemedatalist.categoryName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="attachLink">
              <mat-header-cell *matHeaderCellDef> Attach Link </mat-header-cell>
              <mat-cell *matCellDef="let govtschemedatalist">
                {{ govtschemedatalist.attachLink }}
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator
            [pageSizeOptions]="[5]"
            #paginator
            showFirstLastButtons
            aria-label=""
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid page" *ngIf="selectedIndex === 2">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp; Add a New Government Scheme
  </div>

  <div class="example-header">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="form">
          <div class="fulllwidth">
            <mat-form-field>
              <input
                type="text"
                formControlName="SchemtTitle"
                required
                matInput
                placeholder="Scheme Title"
              />
              <mat-error *ngIf="form.get('SchemtTitle').hasError('required')">
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <textarea
                matInput
                required
                formControlName="Description"
                maxlength="500"
                rows="5"
                style="height: 50px; resize: none !important"
                placeholder="Description"
              ></textarea>
              <mat-error *ngIf="form.get('Description').hasError('required')">
              </mat-error>
            </mat-form-field>

            <div>
              <span>
                <mat-form-field style="width: 68%">
                  <mat-select
                    formControlName="CategoryID"
                    required
                    placeholder="Category"
                  >
                    <mat-option
                      *ngFor="let opt of categorydatalist"
                      (click)="getcategoryId(opt.categoryID)"
                      [value]="opt.categoryName"
                    >
                      {{ opt.categoryName }}
                    </mat-option>
                  </mat-select> </mat-form-field
                >&nbsp;&nbsp;

                <button
                  type="button"
                  class="add_button_new"
                  (click)="openDialog()"
                  mat-raised-button
                  color="primary"
                >
                  Manage Categories</button
                >&nbsp;
              </span>
            </div>
            <mat-form-field>
              <input
                type="text"
                formControlName="Attachedlink"
                placeholder="Add a reference link"
                matInput
              />
            </mat-form-field>

            <mat-form-field>
              <input
                type="text"
                formControlName="Remark"
                placeholder="Remark"
                matInput
              />
            </mat-form-field>

            <div class="row">
              <div class="col-12" style="margin-bottom: 10px">
                <div class="col-12">
                  <p class="pull-left" style="width: 100%; text-align: left">
                    Attach a reference document: A single PDF document or an
                    image file (PNG, JPEG/JPG)
                  </p>
                </div>
                <div class="col-12">
                  <input
                    class="col-6 pull-left"
                    (change)="processImage($event)"
                    type="file"
                    #inputFile
                  />
                  <button
                    class="col-1 pull-left"
                    type="button"
                    (click)="removeFile()"
                    *ngIf="isButtonVisible"
                    matTooltip="remove attachment"
                    style="border: none"
                    mat-stroked-button
                    aria-label="remove file"
                  >
                    <mat-icon [ngStyle]="{ color: 'red' }">clear</mat-icon>
                  </button>
                </div>
              </div>

              <div class="col-md-12">
                <button
                  class="pull-right submitBtn"
                  (click)="onSubmit()"
                  mat-button
                  type="submit"
                  [disable]="disable"
                >
                  Post
                </button>
              </div>
            </div>
            <div *ngIf="requirederror">Please Enter Mandatory Fields</div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
